import { IStoreUiState } from './ui.interface';

/**
 *
 * @param {IStoreUiState} that
 * @param {number} videoId
 */
export function _addVideo(that: IStoreUiState, videoId: number) {
  if (that.downloadedVideo?.includes(videoId) !== true) {
    that.downloadedVideo?.push(videoId);
  }
}

/**
 *
 * @param {IStoreUiState} that
 * @param {number} videoId
 */
export function _hasVideo(that: IStoreUiState, videoId: number): boolean {
  return that.downloadedVideo?.includes(videoId) === true;
}
